import { Box } from "@mui/material"
import { isNil } from "lodash"
import DefaultAlwaysHint from "./AlwaysHints"
import { HintRandomizerDto, checkHintsList } from "./HintsAutocomplete"


interface AlwaysHintsTrackerProps {
    hintDistribution: "scrubs" | "s7" | "multiworld"
    cowsanity: boolean
    scrubsanity: boolean
    direction: "column" | "row"
}

const AlwaysHintsTracker = (props: AlwaysHintsTrackerProps) => {

    let useScrubs = props.hintDistribution === "scrubs";
    let useMultiworld = props.hintDistribution === "multiworld";

    let alwaysHints: Array<HintRandomizerDto> = []

    if (useScrubs)
        alwaysHints = checkHintsList.filter(h => h.type?.includes("scrubs"))
    else {
        alwaysHints = checkHintsList.filter(h => h.type?.includes("always") && isNil(h.alwaysCondition))

        if (useMultiworld) {
            alwaysHints = checkHintsList.filter(h => h.type?.includes("multiworld"))
        }

        if (props.cowsanity)
            alwaysHints = [...alwaysHints, ...checkHintsList.filter(h => h.alwaysCondition === "cowsanity")]
        if (props.scrubsanity)
            alwaysHints = [...alwaysHints, ...checkHintsList.filter(h => h.alwaysCondition === "scrubsanity")]

    }


    return <Box display="flex" flexShrink={1} flexDirection="row" justifyContent={"flex-center"} textAlign={"center"} margin="5px">

        <Box display="flex" flexDirection={props.direction} maxHeight={"180px"} maxWidth={"250px"} flexShrink={1} flexWrap={"wrap"} justifyContent={"flex-start"}>
            {alwaysHints.map((e, i) => {
                return <DefaultAlwaysHint hint={e} />

            })}
        </Box>


    </Box>
}

export default AlwaysHintsTracker